import {
  ANNOTATION_CATEGORIES,
  ANNOTATION_CATEGORY_MAP,
  AnnotationCategoryKey,
  AnnotationCategoryOption
} from 'constants/annotation'
import { ObjectCategory } from 'domain/comment/types'
import { AnnotationType } from 'types/building'

/**
 * Maps an AnnotationType (or existing raw category string) into its corresponding category key ('G' | 'A' | 'S' | 'M' | 'E')
 */
export function mapAnnotationTypeToCategory(
  type?: number | AnnotationType | null,
  rawCat?: string | null
): ObjectCategory {
  if (rawCat && rawCat.trim()) {
    const upper = rawCat.trim().toUpperCase()
    if (['G', 'A', 'S', 'M', 'E'].includes(upper)) {
      return upper as ObjectCategory
    }
  }

  const numType = Number(type)
  switch (numType) {
    case AnnotationType.ARCHITECTURE: // 10
      return AnnotationCategoryKey.ARCHITECTURE // 'A'
    case AnnotationType.AIR_CONDITION: // 20
      return AnnotationCategoryKey.MECHANICAL // 'M'
    case AnnotationType.ELECTRICITY: // 30
      return AnnotationCategoryKey.ELECTRICITY // 'E'
    case AnnotationType.EQUIPMENT: // 100
      return AnnotationCategoryKey.STRUCTURE // 'S'
    default:
      return AnnotationCategoryKey.GENERAL // 'G'
  }
}

/**
 * Returns the category configuration option for a given annotation type or raw category key
 */
export const getRNAnnotationCategory = (
  type?: number | AnnotationType | null,
  rawCat?: string | null
): AnnotationCategoryOption => {
  const catKey = mapAnnotationTypeToCategory(type, rawCat)
  return ANNOTATION_CATEGORY_MAP[catKey] || ANNOTATION_CATEGORIES[0]
}

/**
 * Returns dropdown select options for Renewal annotation categories
 */
export const getAnnotationCategorySelectOptions = (allLabel = 'すべて') => [
  { label: allLabel, value: 'all' },
  ...ANNOTATION_CATEGORIES.map((c) => ({
    label: c.label,
    value: c.key
  }))
]
